export enum EventTypes {
  RESTRAINT = 1,
  SECLUSION = 2,
}
